import { z } from "zod";

export const extractShape = (schema: z.ZodTypeAny): z.ZodRawShape => {
  const unwrapped =
    schema instanceof z.ZodEffects ? schema._def.schema : schema;
  if (unwrapped instanceof z.ZodObject) {
    return unwrapped.shape;
  }
  throw new Error("Cannot extract shape from non-ZodObject schema");
};

export const generateBlankError = <T extends string>(
  keys: readonly T[],
): Record<T, string> => {
  return keys.reduce(
    (acc, key) => {
      acc[key] = ""; // Default blank value for errors
      return acc;
    },
    {} as Record<T, string>,
  );
};
